import { CASES } from '@core/config/cases';
import {
  CASE_GEN_INFORMATION,
  CASE_CONTRACTUAL_MODIF,
  CASE_HIRING,
  CASE_DOCUMENTS,
  CASE_CLAIMS,
  CASE_CUSTOMER_AREA,
  CASE_CANCELLATIONS,
} from '@core/config/sub-cases';
import { InjectionToken } from '@angular/core';
import { CaseItem } from '@core/models';
import { ClientType } from './client-type.constants';

export const casesItems: CaseItem[] = [
  {
    id: CASES.EMAIL,
    title: 'Cases.case_gen_email',
    disallowedToUser: true,
  },
  {
    id: CASES.GEN_INFORMATION,
    title: 'Cases.case_gen_information',
    categories: [
      {
        id: CASE_GEN_INFORMATION.CONTRACT_INFO,
        title: 'Cases.case_gen_information_contract_info',
      },
      {
        id: CASE_GEN_INFORMATION.COMMERCIAL_INFO,
        title: 'Cases.case_gen_information_commercial_info',
      },
      {
        id: CASE_GEN_INFORMATION.SIGN_UP_PROCESS_INFO,
        title: 'Cases.case_gen_information_sign_up_process_info',
      },
    ],
  },
  {
    id: CASES.HIRING,
    title: 'Cases.case_hiring',
    categories: [
      {
        id: CASE_HIRING.ONB_INFO,
        title: 'Cases.case_hiring_onb_info',
      },
      {
        id: CASE_HIRING.OCR_ISSUE,
        title: 'Cases.case_hiring_ocr_issue',
      },
      {
        id: CASE_HIRING.ACCOUNT_ACTIVATION_ISSUE,
        title: 'Cases.case_hiring_account_activation_issue',
      },
      {
        id: CASE_HIRING.FIRST_TRANSFER_ISSUE,
        title: 'Cases.case_hiring_first_transfer_issue',
      },
      {
        id: CASE_HIRING.FIRST_PASSWORD_ISSUE,
        title: 'Cases.case_hiring_first_password_issue',
      },
    ],
  },
  {
    id: CASES.CONTRACTUAL_MODIF,
    title: 'Cases.case_contractual_modif',
    categories: [
      {
        id: CASE_CONTRACTUAL_MODIF.NAME_AND_SURNAME,
        title: 'Cases.case_contractual_modif_name_and_surname',
      },
      {
        id: CASE_CONTRACTUAL_MODIF.CONTACT_DETAILS_PHONE_MAIL,
        title: 'Cases.case_contractual_modif_contact_details_phone_mail',
      },
      {
        id: CASE_CONTRACTUAL_MODIF.LABOR_DATA,
        title: 'Cases.case_contractual_modif_labor_data',
      },
      {
        id: CASE_CONTRACTUAL_MODIF.ADDRESS_CHANGES,
        title: 'Cases.case_contractual_modif_address_changes',
      },
      {
        id: CASE_CONTRACTUAL_MODIF.PRIVACY_POLICY_OR_CONSENTS,
        title: 'Cases.case_contractual_modif_privacy_policy_or_consents',
      },
      {
        id: CASE_CONTRACTUAL_MODIF.BANK_ACCOUNT_CHANGES,
        title: 'Cases.case_contractual_modif_bank_account_changes',
      },
    ],
  },
  {
    id: CASES.DOCUMENTS,
    title: 'Cases.case_documents',
    categories: [
      {
        id: CASE_DOCUMENTS.PROVIDE_DOCUMENTS,
        title: 'Cases.case_documents_provide_documents',
      },
      {
        id: CASE_DOCUMENTS.REQUEST_CONTRACTUAL_DOCUMENTS,
        title: 'Cases.case_documents_request_contractual_documents',
      },
    ],
  },
  {
    id: CASES.CLAIMS,
    title: 'Cases.case_claims',
    categories: [
      // {
      //   id: CASE_CLAIMS.DOUBTS_SUGGESTIONS_IMPROVEMENTS,
      //   title: 'Cases.case_claims_doubts_suggestions_improvements',
      // },
      {
        id: CASE_CLAIMS.COMPLAINTS,
        title: 'Cases.case_claims_complaints',
      },
    ],
  },
  {
    id: CASES.CUSTOMER_AREA,
    title: 'Cases.case_customer_area',
    categories: [
      {
        id: CASE_CUSTOMER_AREA.ACCESS_OPERATIONAL_INCIDENTS,
        title: 'Cases.case_customer_area_access_operational_incidents',
      },
      {
        id: CASE_CUSTOMER_AREA.PASSWORD,
        title: 'Cases.case_customer_area_password',
      },
      {
        id: CASE_CUSTOMER_AREA.TRANSFER_MOVEMENT_ERROR,
        title: 'Cases.case_customer_area_transfer_movement_error',
      },
      {
        id: CASE_CUSTOMER_AREA.REQUEST_DOCS,
        title: 'Cases.case_customer_area_request_docs',
      },
      // {
      //   id: CASE_CUSTOMER_AREA.UNLOCK_ACCOUNT,
      //   title: 'Cases.case_customer_area_unlock_account',
      // },
    ],
  },
  {
    id: CASES.CANCELLATIONS,
    title: 'Cases.case_cancellations',
    categories: [
      {
        id: CASE_CANCELLATIONS.NO_AUTOMATIC_RENEWAL,
        title: 'Cases.case_cancellations_no_automatic_renewal',
      },
      {
        id: CASE_CANCELLATIONS.TOTAL_CANCELLATION_OF_THE_TERM_DEPOSIT,
        title: 'Cases.case_cancellations_total_cancellation_of_the_term_deposit',
        // disableOptionFor: [ClientType.NotEmployee],
      },
      {
        id: CASE_CANCELLATIONS.CANCELLATION_DEMAND_DEPOSIT,
        title: 'Cases.case_cancellations_cancellation_demand_deposit',
        // disableOptionFor: [ClientType.NotEmployee],
      },
    ],
  },
];

export const CASES_ITEMS = new InjectionToken('CASES_ITEMS', {
  providedIn: 'root',
  factory: () => casesItems,
});
